const REVIEW_INVALIDATION_DELAY_MS = 5_000;
const fallbackInvalidationTimeoutByPr = new Map<string, ReturnType<typeof setTimeout>>();

export function scheduleReviewFallbackInvalidation(
  prScopeKey: string,
  invalidateAfterMutation: () => Promise<void>,
) {
  const existingTimeout = fallbackInvalidationTimeoutByPr.get(prScopeKey);
  if (existingTimeout) {
    clearTimeout(existingTimeout);
  }

  const timeout = setTimeout(() => {
    fallbackInvalidationTimeoutByPr.delete(prScopeKey);
    void invalidateAfterMutation();
  }, REVIEW_INVALIDATION_DELAY_MS);

  fallbackInvalidationTimeoutByPr.set(prScopeKey, timeout);
}
